import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { AdminService, BaseComponent, UserService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-create-cognito-user",
  templateUrl: "create-cognito-user.component.html",
  standalone: false,
})
export class CreateCognitoUserComponent extends BaseComponent {
  @Input() user: any;
  public success: boolean = false;
  public password: string = "";
  public loading: boolean = false;
  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    public router: Router,
    public adminService: AdminService
  ) {
    super(userService);
  }

  ngOnInit() {}

  submit() {
    this.loading = true;
    this.adminService.createCognitoUser(this.user.id, { password: this.password }).subscribe((result) => {
      this.activeModal.close(true);
      this.loading = false;
    });
  }
}
